import styled from "styled-components";

export const Header = styled.nav`
  padding: 20px 0;
  background-color: var(--white);
  border-bottom: 1px solid #ededed;
`;

export const Logo = styled.h1`
  font-size: 0em;
  min-width: 70px;
  max-width: 90px;

  img {
    width: 100%;
  }
`;

export const Content = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: var(--max-width-content);
`;

export const Clear = styled.div`
  clear: both;
`;

export const DsFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;